import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { ThreeDots } from 'react-loader-spinner'

const PageNotFound = () => {

    const userLogin = useSelector(state => state.userLogin)
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let timer = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => { clearTimeout(timer) }
    }, []);

    return (
        <>
            {loading ?
                <div className="col-span-6 mt-12 flex justify-center items-center">
                    <ThreeDots
                        height="80"
                        width="80"
                        radius="9"
                        color="#2f4d44"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div> :
                <div className="bg-gray-200 w-full px-16 md:px-0 min-h-screen flex items-center justify-center">
                    <div className="bg-white border border-gray-200 flex flex-col items-center justify-center px-4 md:px-8 lg:px-24 py-8 rounded-lg shadow-2xl">
                        <p className="text-6xl md:text-7xl lg:text-9xl font-bold tracking-wider text-green-900">404</p>
                        <p className="text-2xl md:text-3xl lg:text-5xl font-bold tracking-wider text-gray-500 mt-4"><FormattedMessage id="app.protected.pageNotFound" defaultMessage="Page Not Found" /></p>
                        <p className="text-gray-500 mt-4 pb-4 border-b-2 text-center">
                            <FormattedMessage id="app.protected.pageNotFound.text" defaultMessage="Sorry, the page you are looking for could not be found." /></p>
                        <Link
                            to={'./dashboard'}
                            className="flex items-center space-x-2 bg-green-900 hover:bg-blue-700 text-gray-100 px-4 py-2 mt-6 rounded transition duration-150">
                            Home
                        </Link>
                    </div>
                </div>
            }

        </>
    )
}

export default PageNotFound
